import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ParametroAutonomiaComponent } from './parametro-autonomia.component';

const SECURITY_ROUTES: Routes = [
    { path: 'security/parametroAutonomia', component: ParametroAutonomiaComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
    imports: [
        RouterModule.forChild(SECURITY_ROUTES)
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class ParametroAutonomiaRoutingModule { }
